module.exports = __webpack_public_path__ + "static/media/navigation.ad2c207f.svg";